Object.defineProperty(exports, "__esModule", {
  value: true
});

var fillSegments_1 = require("./fillSegments");

var normalizePoints_1 = require("./normalizePoints");

var fillPoints_1 = require("./fillPoints");

var constants_1 = require("../constants");

var errors_1 = require("../utilities/errors");

var getSortedSegments_1 = require("./getSortedSegments");

function normalizePaths(left, right, options) {
  if (options.optimize === constants_1.FILL) {
    left = getSortedSegments_1.getSortedSegments(left);
    right = getSortedSegments_1.getSortedSegments(right);
  }

  if (left.length !== right.length) {
    if (options.optimize === constants_1.FILL) {
      fillSegments_1.fillSegments(left, right, options.origin);
    } else {
      errors_1.raiseError('optimize:none requires equal lengths');
    }
  }

  var matrix = Array(2);
  matrix[0] = left;
  matrix[1] = right;

  if (options.optimize === constants_1.FILL) {
    var _a = options.origin,
        x = _a.x,
        y = _a.y,
        absolute = _a.absolute;

    for (var i = 0; i < left.length; i++) {
      normalizePoints_1.normalizePoints(absolute, x, y, matrix[0][i]);
      normalizePoints_1.normalizePoints(absolute, x, y, matrix[1][i]);
    }

    fillPoints_1.fillPoints(matrix, options.addPoints * 6);
  }

  return matrix;
}

exports.normalizePaths = normalizePaths;